<template>
  <b-card
    v-if="enable"
    :sub-title="title"
  >
    {{ label }}
    <b-select
      v-model="selectedCategory"
      v-b-tooltip.hover="tooltipTitle"
      :disabled="filterByLocationActive || !(options.length > 1)"
      :options="options"
    />
  </b-card>
</template>

<script lang="ts">

import Component from 'vue-class-component'

import FilterByCategoryMixin from '@/mixins/FilterByCategoryMixin'

@Component
export default class FilterBubblesUI extends FilterByCategoryMixin {
  get enable () {
    return this.filterByCategoryConfig.enable
  }

  get tooltipTitle () {
    return this.filterByLocationActive ? 'Cannot filter by category when search by location is active' : ''
  }
}

</script>
